import { BrandLoading } from "@ondit/ui";
import { useT } from "~/core/i18n";
import { Logo } from "~/shell/logo";

/** A whole page with nothing drawn yet; a region uses `~/core/ui/skeletons`. */
export function PageLoading() {
	const t = useT();
	return (
		<BrandLoading label={t("state.loading")} slowLabel={t("state.loadingSlow")}>
			<Logo variant="mark" />
		</BrandLoading>
	);
}
